__turbopack_context__.v({
  "currentStep": "sanity-content-video-module__QtQGta__currentStep",
  "sanityContentVideo": "sanity-content-video-module__QtQGta__sanityContentVideo",
  "step": "sanity-content-video-module__QtQGta__step",
});
